import messages from '../scripts/frontend-messages';
import userLoggedIn from '../scripts/user-logged-in';
import Modal from "../scripts/modal";
import Cookies from 'js-cookie'
import SiteMessagesInstance from '../components/site-messages'

const userLoginContainer = document.querySelector('.user-login-container');

if(userLoginContainer) {

  const form = userLoginContainer.querySelector('.user-login-form');
  const formContainer = userLoginContainer.querySelector('.user-login__form');
  const btn = userLoginContainer.querySelector('.login-button');

  let token = window.localStorage.getItem('token');

  if(!token) {
    token = Cookies.get('token');
  }

  const urlParams = new URLSearchParams(window.location.search);

  let redirect_url = window.site.home + '/dashboard';
  let redirect = userLoginContainer.dataset.redirect;

  if(!redirect && urlParams.get('redirect')) {
    redirect = urlParams.get('redirect');
  }

  function blacklisted() {
    $(".site-messages-container").after(`
    <div style="background-color: #9f0000; color: white; padding: 10px; margin-bottom: 10px;">
    <p>We're sorry, but your account access has been temporarily restricted. If you believe this is a mistake or 
    need assistance, please contact our customer support team for further details and next steps.</p>
    <p>We appreciate your cooperation and look forward to resolving this with you. Contact us at <b>888.263.6973</b></p>

    </div>
    `)
  }

  if(redirect) {

    switch (redirect) {
      case('blacklist'):

        blacklisted();
        redirect_url = window.site.home + '/';

        break;
      case('onboarding'):
        redirect_url = window.site.home + '/setup';
        break;
      case 'dashboard':
        // Get the "sensor" parameter from the URL

        const sensorId = urlParams.get('sensor');

        if (sensorId) {
          redirect_url = window.site.home + `/dashboard?id=${sensorId}`;
        } else {
          console.warn('Sensor ID not found in URL parameters.');
        }
        break;
    }
  }

  if(token) {
    setTimeout(() => {
      window.location.href = redirect_url;
    }, 1000);

  } else {
    $(userLoginContainer).show();
  }

  let isShowingPassword = false;
  const $passwordInput = $(form).find('input[name="password"]');
  const $showHidePassword = $(form).find('.user-login-show-hide-password');

  const toggleShowHidePassword = () => {

    isShowingPassword = !isShowingPassword;
    $showHidePassword.toggleClass('is-active', isShowingPassword);

    if(isShowingPassword) {
      $passwordInput[0].type = 'text';
      $showHidePassword.html('<i class="fas fa-eye"></i>');
    } else {
      $passwordInput[0].type= 'password';
      $showHidePassword.html('<i class="fas fa-eye-slash"></i>');
    }

  }

  $showHidePassword.on('click', toggleShowHidePassword);

  $(form).on('submit', e => {

    e.preventDefault();

    $(formContainer).toggleClass('loading-overlay', true);
    $(btn).attr('disabled', true);

    const remember_me = $(form).find('[name="remember_me"]').is(':checked') ? 1 : 0;
    const username = $(form).find('[name="email"]').val();

    $.ajax({
      url: window.site.api + '/login',
      type: 'post',
      data: {
        username,
        password: $(form).find('[name="password"]').val(),
        remember_me,
      },
      dataType: 'json',
      success: r => {
        if (r.type === 'success') {

          const data = r.data;

          window.loginSession = r.data;

          window.localStorage.setItem('token', data.token);
          Cookies.set('token', encodeURIComponent(data.token), { expires: 365 });

          window.location.href = redirect_url;

        } else {

          $(formContainer).toggleClass('loading-overlay', false);

          if(r.message === 'blacklisted') {
            blacklisted();
          } else {

            console.log(r);
            messages.showError(r.message);

            $(btn).removeAttr('disabled');

          }

        }
      },
      error: (xhr, textStatus, errorThrown) => {

        messages.showError(`
          You might not be connected to the internet or a firewall is blocking the connection<br>
          Call customer support at <b>888.263.6973</b>`
        );

        $(formContainer).toggleClass('loading-overlay', false);
        $(btn).removeAttr('disabled');

      },
    });

  });

  $('.new-user-button').on('click', () => {

    const modal = new Modal({
      class: ['modal'],
      title: 'Create Account',
    });

    modal.setContent(`

      <p>Create a new Temp Stick account to view your sensor data</p>
      <form data-for="create-account" method="post">
        <div class="setting">
          <div class="setting__label">Email</div>
          <input type="email" name="email" placeholder="youremail@mail.com" required />
        </div>
        <div class="setting">
          <div class="setting__label">Password</div>
          <input type="password" name="password" required />
        </div>
        
        <div class="setting-save">
          <div class="setting-save__button">
            <button type="submit" class="button button--blue">Create Account</button>
          </div>
          <div class="setting-save__message"></div>
        </div>
  
      </form>
      
    `);

    const container = modal.getContainer();
    const $form = $(container).find('form[data-for="create-account"]');

    $form.on('submit', e => {

      e.preventDefault();

      const $btn = $form.find('setting-save__button');
      const $message = $form.find('.setting-save__message');

      $btn.attr('disabled', true);
      $message.html('Creating account...');

      window.apiRequestNoToken('post', '/user/create', $form.serialize()).then(r => {

        setTimeout(() => {

          if(r.type === 'success') {
            SiteMessagesInstance.addMessage('success', 'Successfully created your account, you may log in now');
            SiteMessagesInstance.displayMessages();
            modal.close();
          } else {
            $message.html(r.message);
          }

        }, 200);

      });

    });

    modal.open();

  });

  $('.forgot-password-button').on('click', () => {

    const modal = new Modal({
      class: ['modal'],
      title: 'Forgot Password',
    });

    modal.setContent(`
    <form action="" method="post" data-for="reset_password">
      <p>Enter your login email and we'll send password reset instructions to that account</p>
      
      <div class="forgot-password-modal">
      
        <input type="email" name="email" required class="forgot-password-modal__email" placeholder="yourlogin@email.com" autocomplete="off" autocapitalize="off" />
        
        <input type="email" name="email_again" class="forgot-password-modal__email-again" title="This is a robot verification field, do not use" placeholder="This is a robot verification field, do not use" autocomplete="off" autocapitalize="off" />
        
        <button type="submit" class="forgot-password-modal__submit button button--medium">Reset Password</button>        
        
      </div>
      
      <div class="forgot-password-modal__message"></div>
      
    </form>
    `);

    const container = modal.getContainer();
    const $message = $(container).find('.forgot-password-modal__message');
    const $btn = $(container).find('forgot-password-modal__submit');

    $(container).on('change', () => {
      $btn.removeAttr('disabled');
      $message.html('');
    });

    $(container).find('form').on('submit', e => {

      e.preventDefault();
      $btn.attr('disabled', true);
      $message.html('Processing...');

      window.apiRequestNoToken('post', '/forgot-password', $(e.currentTarget).serialize()).then(r => {
        if (r.type === 'success') {

          setTimeout(() => {
            $message.html(r.message);
          }, 100);

        } else {
          $message.html(r.message);
        }

      });

    });

    modal.open();

  });

}
